/*global jQuery */
(function($, window, document) {
  'use strict';

  function getId() {
    let $url = $(location).attr('href');
    let $id = $url.split('#')[1];
    if ($id) {
      $id = $id.split('?')[0];
    }
    return $id;
  }

    function scrollToAnchor($id) {
      let $targetElement = $('#' + $id);
      let $headHeight = $('.SectionHeader').outerHeight() + 10;

      if ($targetElement.length) {
        $('html, body').animate({
          scrollTop: $targetElement.offset().top - $headHeight
        }, 500);
      }
    }

  function init() {
    let $anchorId = getId();
    if($anchorId) {
      scrollToAnchor($anchorId);
    }
  }

  $(document).ready(function(){
    setTimeout(init, 500);
  });

}(jQuery, window, document));
